import BaseService from "../CorBase/BaseService";

export class ContentPreviewService extends BaseService {
	constructor() {
		super('/contentpreview');
	}
}